export * from './i18n/i18n.service'
export * from './interact/interact.service'
export * from './loader/loader.service'
export * from './logger/logger.service'
export * from './multi-lingual/multi-lingual.service'
export * from './validations/validations.service'
export * from './validations/validationsUtil.service'
export * from './global-error-handler/global-error-handler.service'

import { I18nService } from './i18n/i18n.service'
import { InteractService } from './interact/interact.service'
import { LoaderService } from './loader/loader.service'
import { Logger } from './logger/logger.service'
import { MultiLingualService } from './multi-lingual/multi-lingual.service'
import { ValidationService } from './validations/validations.service'
import { ValidationUtilService } from './validations/validationsUtil.service'

// Since we moved to ngx-translate, we'll not be using multi-ligual service
// hence, it's not listed in the Provider list below.
export const SERVICEPROVIDERS = [
    I18nService,
    InteractService,
    LoaderService,
    Logger,
    ValidationService,
    MultiLingualService,
    ValidationUtilService
]